import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse } from '../BaseService';
import { cache } from './Cache';
import { IFacetResults } from './FacetTypes';
import { IPrepareFacetsUrl, prepareFacetsUrl } from './PrepareFacetsUrl';
import { TAG_TYPES } from './Types';

const debug = require('debug')('tca:service:SearchService');

interface IFacets extends IPrepareFacetsUrl {
  getFromCache?: boolean;
}

export interface IFacetResponse extends IHttpResponse {
  body?: IFacetResults;
}

export const facets = async ({
  getFromCache,
  tagType,
  ...buildUrlProps
}: IFacets): Promise<IFacetResponse> => {
  debug('facets');
  const url = prepareFacetsUrl({
    tagType,
    facet: tagType === TAG_TYPES.SCRIPTURE ? 'books' : 'tags',
    ...buildUrlProps,
  });

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    getFromCache,
    skipTimestamp: true,
    cache,
    token: guestToken,
  });
};
